import { useEffect } from 'react';
import { Box, Typography, CircularProgress } from '@mui/material';
import { useSession, SessionProvider } from './contexts/SessionContext';
import { UIProvider } from './contexts/UIContext';
import SessionValidation from './components/SessionValidation';
import AppRoutes from './routes/AppRoutes';
import { fetchStatsConfig } from './services/statsConfig.service';

const AppContent = () => {
  const {
    isLoading,
    loadingMessage,
    showValidation,
    session,
    completeValidation,
  } = useSession();

  // Fire-and-forget — warms the in-memory stats-config cache for the
  // session; StatsPanelLayout falls back to the static list until this
  // resolves (or forever, if it fails).
  useEffect(() => {
    fetchStatsConfig();
  }, []);

  if (isLoading) {
    return (
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          height: '100vh',
          gap: 2,
          backgroundColor: '#1E1E1E',
          color: '#FFFFFF',
        }}
      >
        <CircularProgress sx={{ color: '#45FFD5' }} />
        <Typography variant="body1" sx={{ color: '#FFFFFF' }}>
          {loadingMessage || 'Initializing...'}
        </Typography>
      </Box>
    );
  }

  if (showValidation) {
    return (
      <SessionValidation
        session={session}
        onValidationComplete={completeValidation}
      />
    );
  }
  return <AppRoutes />;
};

function App() {
  return (
    <SessionProvider>
      <UIProvider>
        <AppContent />
      </UIProvider>
    </SessionProvider>
  );
}

export default App;
